<template>
  <div class="contractManage">
    <div class="content-container">
      <div class="titieMian">
        <div class="title-container">合同管理</div>
        <div class="select-container">
          <div class="select-container-box">
            <el-input
              v-model="filters.contractName"
              size="small"
              clearable
              class="search-input"
              placeholder="请输入合同名称"
              @keyup.enter.native="search(1)"
            />
          </div>
          <div class="select-container-box">
            <el-input
              v-model="filters.tenantName"
              size="small"
              clearable
              class="search-input"
              placeholder="请输入承租方名称"
              @keyup.enter.native="search(1)"
            />
          </div>
          <div class="select-container-box">
            <el-select v-model="filters.contractStatus" clearable size="small" class="long-select" placeholder="请选择合同状态">
              <el-option
                v-for="item in contractStatusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
          <div class="select-container-box">
            <el-button size="small" type="info" plain class="query" @click="search(1)">查询</el-button>
            <el-button size="small" type="info" plain @click="resetSearch">重置</el-button>
            <el-button
              size="small"
              type="info"
              plain
              class="add"
              style="background:#FF812D;color:#fff;border-color:#FF812D"
              v-if="edit"
              @click="onAdd"
            >新增</el-button>
          </div>
        </div>
      </div>

      <div class="table-container">
        <el-table :data="list" style="width:100%" size="medium">
          <i slot="empty" style="font-style:normal">暂无数据</i>
          <el-table-column label="序号" type="index" align="center" width="60" />
          <el-table-column prop="contractCode" label="合同编号" align="center" min-width="160" show-overflow-tooltip />
          <el-table-column prop="contractName" label="合同名称" align="center" min-width="140" show-overflow-tooltip />
          <el-table-column prop="tenantName" label="承租方名称" align="center" width="120" show-overflow-tooltip />
          <el-table-column prop="tenantPhone" label="承租方手机号" align="center" width="130" show-overflow-tooltip />
          <el-table-column label="开始日期" align="center" width="110">
            <template slot-scope="scope">{{ formatDate(scope.row.contractStart) }}</template>
          </el-table-column>
          <el-table-column label="结束日期" align="center" width="110">
            <template slot-scope="scope">{{ formatDate(scope.row.contractEnd) }}</template>
          </el-table-column>
          <el-table-column label="合同状态" align="center" width="100">
            <template slot-scope="scope">
              <LeaseStatusTag kind="contract" :value="scope.row.contractStatus" />
            </template>
          </el-table-column>
          <el-table-column label="缴费情况" align="center" width="100">
            <template slot-scope="scope">
              <LeaseStatusTag kind="payment" :value="scope.row.paymentStatus" />
            </template>
          </el-table-column>
          <el-table-column prop="totalRent" label="租金(元)" align="center" width="110" />
          <el-table-column prop="paidAmount" label="已缴(元)" align="center" width="110" />
          <el-table-column prop="unpaidAmount" label="未缴(元)" align="center" width="110" />
          <el-table-column label="操作" align="center" width="320" fixed="right">
            <template slot-scope="scope">
              <div class="action-row">
                <span class="content-edit" @click="onDetail(scope.row)">详情</span>
                <span
                  class="content-edit"
                  v-if="edit"
                  @click="onEdit(scope.row)"
                >编辑</span>
                <span
                  class="content-del"
                  v-if="edit"
                  @click="onDelete(scope.row)"
                >删除</span>
              </div>
              <div class="action-row" v-if="edit">
                <span
                  class="content-edit"
                  v-if="canDownloadTemplate(scope.row)"
                  @click="onDownloadContract(scope.row)"
                >下载合同模板</span>
                <span
                  class="content-edit"
                  v-if="canDownloadTemplate(scope.row)"
                  @click="openSign(scope.row)"
                >合同签约</span>
                <span class="content-del" @click="onTerminate(scope.row)">终止合同</span>
                <span class="content-edit" @click="openPay(scope.row)">线下代缴</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <page-change :pageInfo="pageInfo"></page-change>
    </div>

    <el-dialog
      title="合同签约"
      :visible.sync="signVisible"
      width="520px"
      custom-class="lease-ylw-dialog"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form ref="signForm" :model="signForm" :rules="signRules" label-width="100px" size="small">
        <el-form-item label="签约文件" prop="signedFileUrl">
          <lease-file-upload
            v-model="signForm.signedFileUrl"
            tip="请上传已签署合同文件（pdf/doc/docx）"
            button-text="上传签约文件"
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="signVisible = false">取消</el-button>
        <el-button type="primary" :loading="signLoading" @click="submitSign">确定</el-button>
      </span>
    </el-dialog>

    <offline-pay-dialog ref="offlinePay" @success="search(pageInfo.pageNumber)" />
  </div>
</template>

<script>
import moment from "moment";
import mixins from "@/common/MixIn.js";
import PageChange from "@/components/common/PageChange.vue";
import LeaseFileUpload from "@/components/fishPondLease/common/LeaseFileUpload.vue";
import OfflinePayDialog from "@/components/fishPondLease/common/OfflinePayDialog.vue";
import LeaseStatusTag from "@/components/fishPondLease/common/LeaseStatusTag.vue";
import {
  pageContract,
  deleteContract,
  signContract,
  terminateContract,
  downloadContractFile,
  leaseRequestError
} from "@/service/fishPondLease";
import {
  ContractStatus,
  ContractStatusOptions,
  enumLabel
} from "@/service/fishPondLeaseEnums";

export default {
  name: "ContractManage",
  mixins: [mixins],
  components: { PageChange, LeaseFileUpload, OfflinePayDialog, LeaseStatusTag },
  data() {
    return {
      list: [],
      filters: {
        contractName: "",
        tenantName: "",
        contractStatus: null
      },
      contractStatusOptions: ContractStatusOptions,
      pageInfo: {
        pageNumber: 1,
        totalPages: 0,
        pageFunc: this.search,
        pageSize: 10
      },
      signVisible: false,
      signLoading: false,
      signContractId: null,
      signForm: { signedFileUrl: "" },
      signRules: {
        signedFileUrl: [{ required: true, message: "请上传签约文件", trigger: "change" }]
      }
    };
  },
  async mounted() {
    await this.initPagePermission();
    this.search(1);
  },
  methods: {
    enumLabel,
    formatDate(val) {
      if (!val) return "-";
      return moment(val).format("YYYY-MM-DD");
    },
    // 下载合同模板/合同签约：合同未生效履行时显示（新建/待签约）
    canDownloadTemplate(row) {
      const s = Number(row.contractStatus);
      return s === ContractStatus.New || s === ContractStatus.PendingSign;
    },
    search(pageNum) {
      const pageIndex = pageNum || this.pageInfo.pageNumber || 1;
      this.pageInfo.pageNumber = pageIndex;
      const params = {
        pageIndex: pageIndex,
        pageSize: this.pageInfo.pageSize,
        contractName: this.filters.contractName || undefined,
        tenantName: this.filters.tenantName || undefined,
        contractStatus:
          this.filters.contractStatus === null || this.filters.contractStatus === ""
            ? undefined
            : this.filters.contractStatus
      };
      pageContract(params)
        .then(res => {
          const data = (res && res.data) || {};
          this.list = data.list || [];
          this.pageInfo.totalPages = data.total || 0;
        })
        .catch(err => {
          this.$message.error(leaseRequestError(err));
        });
    },
    resetSearch() {
      this.filters = {
        contractName: "",
        tenantName: "",
        contractStatus: null
      };
      this.search(1);
    },
    onAdd() {
      this.$router.push({ name: "contractForm" });
    },
    onEdit(row) {
      this.$router.push({ name: "contractForm", query: { id: row.id } });
    },
    onDetail(row) {
      this.$router.push({ name: "contractDetail", query: { id: row.id } });
    },
    onDelete(row) {
      this.$confirm("确认删除该合同？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => deleteContract(row.id))
        .then(() => {
          this.$message.success("删除成功");
          this.search(this.pageInfo.pageNumber);
        })
        .catch(err => {
          if (err === "cancel" || err === "close") return;
          this.$message.error(leaseRequestError(err));
        });
    },
    openSign(row) {
      this.signContractId = row.id;
      this.signForm.signedFileUrl = "";
      this.signVisible = true;
      this.$nextTick(() => {
        if (this.$refs.signForm) this.$refs.signForm.clearValidate();
      });
    },
    submitSign() {
      this.$refs.signForm.validate(valid => {
        if (!valid) return;
        this.signLoading = true;
        signContract({
          contractId: this.signContractId,
          signedFileUrl: this.signForm.signedFileUrl
        })
          .then(() => {
            this.$message.success("签约成功");
            this.signVisible = false;
            this.search(this.pageInfo.pageNumber);
          })
          .catch(err => {
            this.$message.error(leaseRequestError(err));
          })
          .finally(() => {
            this.signLoading = false;
          });
      });
    },
    openPay(row) {
      if (this.$refs.offlinePay) {
        this.$refs.offlinePay.open(row.id);
      }
    },
    onTerminate(row) {
      this.$prompt("请输入终止备注（可选）", "终止合同", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPlaceholder: "备注",
        inputValue: ""
      })
        .then(function(result) {
          return terminateContract({
            contractId: row.id,
            remark: (result && result.value) || ""
          });
        })
        .then(() => {
          this.$message.success("已终止");
          this.search(this.pageInfo.pageNumber);
        })
        .catch(err => {
          if (err === "cancel" || err === "close") return;
          this.$message.error(leaseRequestError(err));
        });
    },
    onDownloadContract(row) {
      downloadContractFile(row.id).catch(err => {
        this.$message.error(leaseRequestError(err));
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.contractManage .content-container .titieMian .select-container
  margin-top -5px
.action-row
  line-height 22px
  white-space nowrap
  & + .action-row
    margin-top 4px
.content-edit
  color #3389ff
  cursor pointer
  margin 0 6px
.content-del
  color #f56c6c
  cursor pointer
  margin 0 6px
</style>
